import { setSliceMultipleSelectedList } from '../../../../redux/slices/FJSliceCommunity';
import { useSelector, useDispatch } from 'react-redux';
import useLocalStore from '../../../../hooks/useLocalStore';
import FJConstant from '../../../../constants/FJConstant';
import FJCommunitySelectAll from './FJCommunitySelectAll';
import { useMemo, useCallback } from 'react';
import FJActionCommunity from '../../../../redux/action/FJActionCommunity';
import { PUBLISH_TYPE, SUPPORT_COMMUNITY_TOOL_KEY } from '../../../../config/dataConfig/FJCommunityData';
const FJCommunitySelectAllContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const myCreationsDetailList = useSelector(state => state.community.myCreationsDetailList);
    const sharedCreationsList = useSelector(state => state.community.sharedCreationsList);
    const multipleSelectedList = useSelector(state => state.community.multipleSelectedList);
    const myCreationsPageScene = useSelector(state => state.community.myCreationsPageScene);
    const mySpaceTabType = useSelector(state => state.community.mySpaceTabType);
    const myCreationsDetailInfo = useSelector(state => state.community.myCreationsDetailInfo);
    const list = useMemo(() => {
        if (mySpaceTabType === FJConstant.SHARED_CREATIONS) {
            return sharedCreationsList;
        } else if (mySpaceTabType === FJConstant.MY_CREATIONS && myCreationsPageScene === FJConstant.DETAIL) {
            return myCreationsDetailList;
        }
        return [];
    }, [myCreationsPageScene, mySpaceTabType, myCreationsDetailList, sharedCreationsList]);
    const setSelectList = useCallback(
        value => {
            dispatch(setSliceMultipleSelectedList(value));
        },
        [dispatch],
    );
    const clearSelected = useCallback(() => {
        dispatch(setSliceMultipleSelectedList([]));
    }, [dispatch]);
    const isMultipleMode = useMemo(() => {
        return multipleSelectedList.length > 0;
    }, [multipleSelectedList]);
    const multiDelete = useCallback(
        ids => {
            dispatch(FJActionCommunity.multiDeleteAction(ids));
        },
        [dispatch],
    );
    const multiDownload = useCallback(
        (ids, callback) => {
            const items = list.filter(item => ids.includes(item.id));
            dispatch(FJActionCommunity.multiDownloadAction(items, callback));
        },
        [dispatch, list],
    );
    const multiVideoEdit = useCallback(
        (ids, callback) => {
            const items = list.filter(item => ids.includes(item.id));
            dispatch(FJActionCommunity.multiVideoEditAction(items, callback));
        },
        [dispatch, list],
    );
    const multiPrivacySettingChange = useCallback(
        (ids, value, callback) => {
            const items = list.filter(item => ids.includes(item.id) && item.privacyStatus !== PUBLISH_TYPE.DOWN);
            dispatch(FJActionCommunity.multiPrivacySettingChangeAction(items, value, callback));
        },
        [dispatch, list],
    );
    const multiPrivacy = useMemo(() => {
        if (list && list.length > 0) {
            const values = Array.from(
                new Set(list.filter(item => multipleSelectedList.includes(item.id)).map(item => item.privacyStatus)),
            );
            return values.length > 1 ? '' : values.join();
        }
        return '';
    }, [list, multipleSelectedList]);
    const isShow = useMemo(() => {
        return multipleSelectedList.length > 0;
    }, [multipleSelectedList]);

    const hidePrivacySetting = useMemo(() => {
        return (
            !SUPPORT_COMMUNITY_TOOL_KEY.includes(myCreationsDetailInfo.toolKey) &&
            myCreationsPageScene === FJConstant.DETAIL
        );
    }, [myCreationsDetailInfo.toolKey, myCreationsPageScene]);
    return (
        <FJCommunitySelectAll
            isShow={isShow}
            list={list}
            selectList={multipleSelectedList}
            setSelectList={setSelectList}
            multiDelete={multiDelete}
            isMultipleMode={isMultipleMode}
            clearSelected={clearSelected}
            multiDownload={multiDownload}
            multiVideoEdit={multiVideoEdit}
            multiPrivacySettingChange={multiPrivacySettingChange}
            multiPrivacy={multiPrivacy}
            hidePrivacySetting={hidePrivacySetting}
        />
    );
};
export default FJCommunitySelectAllContainer;
